import { Injectable, inject } from '@angular/core';
import {
  ApiDeviceGroupActionResponseDto,
  ApiDeviceGroupListResponseDto,
  ApiDeviceGroupRequestDto,
  ApiDeviceGroupResponseDto,
  DeviceGroupsApiService
} from '@birco/rainmesh-api';
import {Observable} from 'rxjs';
import { DeviceGroupService } from '../api/device-group-state-service.interface';
import { DeviceGroupFilter } from '../../../features/devices/state/device-groups/device-group.state';

@Injectable({
  providedIn: 'root'
})
export class DeviceGroupServiceImpl implements DeviceGroupService {
  private deviceGroupsApiService = inject(DeviceGroupsApiService);


  getDeviceGroups(options: DeviceGroupFilter): Observable<ApiDeviceGroupListResponseDto> {
    return this.deviceGroupsApiService.getDeviceGroups(
      options.pageSize,
      options.page,
      options.sortBy,
      options.sortDir,
      options.searchTerm,
      options.deviceId
    );
  }

  triggerDeviceGroupAction(options: { id: string, value: boolean }): Observable<ApiDeviceGroupActionResponseDto> {
    return this.deviceGroupsApiService.triggerDeviceGroupAction(options.id, {
      value: options.value,
    });
  }

  getDeviceGroupById(options: { id: string }): Observable<ApiDeviceGroupResponseDto> {
    return this.deviceGroupsApiService.getDeviceGroup(options.id);
  }

  createDeviceGroup(options: ApiDeviceGroupRequestDto): Observable<ApiDeviceGroupResponseDto> {
    return this.deviceGroupsApiService.createDeviceGroup(options);
  }

  updateDeviceGroup(options: { id: string; requestDto: ApiDeviceGroupRequestDto }): Observable<ApiDeviceGroupResponseDto> {
    return this.deviceGroupsApiService.updateDeviceGroup(options.id, options.requestDto);
  }

  deleteDeviceGroup(options: { id: string }): Observable<void> {
    return this.deviceGroupsApiService.deleteDeviceGroup(options.id);
  }
}
